import React from "react";
import { Empty, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import EChartsReact from "echarts-for-react";
import DashboardService from "../../Services/DashboardService";
import { EmptyIcon } from "../../Common/FullPageSpinner";

const PracticeUserCard = ({ fromDate, toDate }: { fromDate: string; toDate: string }) => {
  const [chartOptions, setChartOptions] = React.useState<any>({ xData: [], seriesData: [] });
  const [loader, setLoader] = React.useState<boolean>(false);
  const [selectedFilter, setSelectedFilter] = React.useState<string>("total"); 
  const [rawData, setRawData] = React.useState<any[]>([]);

  React.useEffect(() => {
    setLoader(true);
    DashboardService.getPracticeUserDetails(fromDate, toDate)
      .then((response) => {
        if (response?.result && response?.result?.length > 0) {
          setRawData(response?.result);
          applyFilter(selectedFilter, response?.result);
        } else {
          setRawData([]);
          setChartOptions({ xData: [], seriesData: [] });
        }
      })
      .catch((error) => {
        console.error("Error fetching chart data:", error);
      })
      .finally(() => setLoader(false));
  }, [fromDate, toDate]);

  const applyFilter = (filter: string, data: any[]) => {
    const xData = data?.sort((a,b)=> a?.id - b?.id)?.map((ch: any) => `${ch?.id}`) || [];
    const seriesData = data?.map((ch: any) => {
      const base = {
        value: ch?.total ?? 0,
        active: ch?.active ?? 0,
        inActive: ch?.inActive ?? 0,
        deleted: ch?.deleted ?? 0,
        id: ch?.id ?? "",
      };
      switch (filter) {
        case "active":
          return { ...base, value: ch?.active ?? 0 };
        case "inActive":
          return { ...base, value: ch?.inActive ?? 0 };
        case "deleted":
          return { ...base, value: ch?.deleted ?? 0 };
        default:
          return base;
      }
    }) || [];
    setChartOptions({ xData, seriesData });
  };

  React.useEffect(() => {
    if (rawData && rawData?.length > 0) applyFilter(selectedFilter, rawData);
  }, [selectedFilter]);

  return (
    <Spin spinning={loader} indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />}>
      {chartOptions?.xData?.length > 0 && chartOptions?.seriesData?.length > 0 ? (
        <EChartsReact
        option={{
          tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" },
            confine: true,
            formatter: (params: any) => {
              const p = Array.isArray(params) ? params[0] : params;
              const d = (p && (p.data || p)) || {};
              return `<strong>Practice ${d.id ?? "-"}</strong><br/>Total: ${d.value ?? 0}<br/>Active: ${d.active ?? 0}<br/>Inactive: ${d.inActive ?? 0}<br/>Deleted: ${d.deleted ?? 0}`;
            },
          },
          grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
          toolbox: {
                show: true,
                showTitle: false,
                orient: "vertical",
                right: 13,
                top: 24,  
                feature: {
                  // dataView: { show: true, readOnly: false },
                  magicType: { show: true, type: ["line", "bar"] },
                  saveAsImage: { show: true },
                },
              },
          xAxis: [{ type: "category", data: chartOptions?.xData, axisTick: { alignWithLabel: true } }],
          yAxis: [{ type: "value" }],
          series: [
            {
              name: `${selectedFilter.charAt(0).toUpperCase() + selectedFilter.slice(1)} Users`,
              type: "line",
              smooth: true,
              showSymbol: false,
              data: chartOptions?.seriesData,
              emphasis: { focus: "series" },
            },
          ],
        }}
      />
      ):(
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 60, gap: 10 }}><EmptyIcon  /></div>
    )  }
    </Spin>
  );
};

export default PracticeUserCard;
